import { render, staticRenderFns } from "./FeedPrice.vue?vue&type=template&id=46393f2e&scoped=true"
import script from "./FeedPrice.vue?vue&type=script&lang=js"
export * from "./FeedPrice.vue?vue&type=script&lang=js"
import style0 from "./FeedPrice.vue?vue&type=style&index=0&id=46393f2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46393f2e",
  null
  
)

export default component.exports